<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item>回放列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>精彩回顾</span>
        </p>
        <el-divider></el-divider>
      </div>
      <none-view v-if="list.length === 0" :login="load.login" :loading="load.loading" :data="list" :text="load.text"></none-view>
      <div class="reception_live_list">
        <div v-for="item in list" :key="item.id" class="reception_live_item" @click="jump(item.list_id)">
          <div class="reception_live_item_top">
            <p class="reception_live_item_top_icon">
              {{item.add_time}}
            </p>
            <img :src="item.img" alt="">
          </div>
          <div class="reception_live_item_bottom">
            <dl class="reception_live_info">
              <dt class="reception_live_title">
                <span class="reception_live_title_tag">回顾</span>
                {{item.title}}
              </dt>
              <dd class="reception_live_user">主讲人：{{item.user_name}}</dd>
            </dl>
            <div class="reception_live_list_item_other">
              <div class="reception_lately_other">
                <span><i class="font_i">{{item.count}}</i> 人参与</span>
                <el-divider direction="vertical"></el-divider>
                <span><i class="font_i">{{item.comment_count}}</i> 条评论</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="list.length > 0" class="hr_page">
      <page-button :list = "list"
      :limit = "morePage.limit"
      @page = "page"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import none from '../Public/none.vue'
import page from '../Public/page.vue'
export default {
  components: {
    noneView: none,
    pageButton: page
  },
  data () {
    return {
      load: {
        login: false,
        loading: true,
        text: '暂无最近直播内容',
        data: []
      },
      list: [],
      morePage: {
        limit: 4,
        page: 1
      }
    }
  },
  created () {
    this.getLivelist()
  },
  methods: {
    getLivelist () {
      const vueThat = this
      vueThat.myApi.videolist(vueThat.morePage).then((res) => {
        if (res.data.code === 200) {
          vueThat.list.push(...res.data.data)
        }
      })
    },
    jump (id) {
      const routeData = this.$router.resolve({
        path: '/receptionVideoDetail/:id',
        query: { id: id }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    page (num) {
      this.morePage.page = num
      this.getLivelist()
    }
  }
}
</script>

<style>
</style>
